import React, { useEffect, useState } from "react";
import { Card, Row, Col } from "react-bootstrap";
import Topbar from "./Navigations/Topbar";
import Footer from "../Footer";
import { Link } from "react-router-dom";
import { getWishlistProductsByCustomerId } from "../../service/WishlistService";
import { getCartProductsByCustomerId } from "../../service/CartService";

const Profile = ({ authUser }) => {
  const [cart, setCart] = useState([]);
  const [wishlist, setWishlist] = useState([]);

  const fetchData = async () => {
    if (!authUser) {
      return (
        <div className="d-flex vh-100 align-items-center justify-content-center">
          <h3 className="text-muted">Please log in to view your profile.</h3>
        </div>
      );
    }
    const cartData = await getCartProductsByCustomerId(authUser.id);
    const response = await getWishlistProductsByCustomerId(authUser.id);
    setCart(cartData)
    setWishlist(response);
  }

  useEffect(() => {
    fetchData();
  }, [])


  return (
    <>
      <header className="header style7">
        <Topbar flag={true} />
      </header>
      <div className="container py-5">
        {/* Page Heading */}
        <div className="text-center mb-5">
          <h1 className="fw-bold display-4 text-gold " style={{ fontSize: "40px" }}>My Profile</h1>
          <p className="text-muted" style={{ fontSize: '30px', fontWeight: '600' }}>
            Welcome back, <span className="fw-semibold">{authUser?.name}</span>{" "}
            ✨
          </p>
        </div>

        <Row className="justify-content-center">
          {/* Left Column - Profile Card */}
          <Col md={4} className="mt-2">
            <Card className="shadow border-0 rounded-4 text-center">
              <Card.Body>
                <img
                  src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                  alt="Profile"
                  className="rounded-circle mb-3"
                  style={{
                    width: "120px",
                    height: "120px",
                    border: "4px solid #d4af37",
                  }}
                />
                <h4 className="fw-bold fs-2">{authUser?.name}</h4>
                <p className="text-muted fs-3">{authUser?.email}</p>
                {/* <Button variant="outline-dark" className="rounded-pill mt-3 px-4">
                Edit Profile
              </Button> */}
              </Card.Body>
            </Card>
          </Col>

          {/* Right Column - Details */}
          <Col md={6} className="mt-2">
            <Card className="shadow border-0 rounded-4">
              <Card.Body className="p-4">
                <h5 className="fw-bold mb-5 fs-3 text-gold">Personal Details</h5>
                <Row className="mb-3">
                  <Col sm={4} className="fw-semibold fs-5">
                    Full Name
                  </Col>
                  <Col sm={8} className="fs-3">{authUser?.name}</Col>
                </Row>
                <Row className="mb-3">
                  <Col sm={4} className="fw-semibold fs-5">
                    Email
                  </Col>
                  <Col sm={8} className="fs-3">{authUser?.email}</Col>
                </Row>
                <Row className="mb-3">
                  <Col sm={4} className="fw-semibold fs-5">
                    Phone
                  </Col>
                  <Col sm={8} className="mb-5 pb-5 fs-3">{authUser?.phone || "Not Provided"}</Col>
                </Row>
                {/* <Row>
                  <Col sm={4} className="fw-semibold">
                    Address
                  </Col>
                  <Col sm={8}>
                    {authUser?.address
                      ? `${authUser?.address}, ${authUser?.city}, ${authUser?.state}, ${authUser?.country} - ${authUser?.zip_code}`
                      : "Not Provided"}
                  </Col>
                </Row> */}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
      <Footer />
      <div className="footer-device-mobile">
        <div className="wapper">
          <div className="footer-device-mobile-item device-home">
            <Link to="/" className="text-decoration-none">
              <span className="icon">
                <i className="ph ph-house"></i>
              </span>{" "}
              Home
            </Link>
          </div>
          <div className="footer-device-mobile-item device-home device-cart">
            <Link to="/wishlist" className="text-decoration-none">
              <span className="icon">
                <i className="ph ph-heart"></i>
                <span className="count-icon">{wishlist.length}</span>
              </span>{" "}
              Wishlist
            </Link>
          </div>
          <div className="footer-device-mobile-item device-home device-cart">
            <Link to="/shopping-cart" className="text-decoration-none">
              <span className="icon">
                <i className="ph ph-shopping-cart-simple" />
                <span className="count-icon">{cart.length}</span>
              </span>{" "}
              Cart
            </Link>
          </div>
          <div className="footer-device-mobile-item device-home device-user">
            <Link to="/profile" className="text-decoration-none">
              <span className="icon">
                <i className="ph ph-user"></i>
              </span>{" "}
              Account
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
